<script>
export default {
    name: "QueueDashboard",

    data() {

        return {
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
        };
    },

    components: {

      "inpatient-tab": () => import('../tabs/Inpatient.vue'),
      "inpatientorders-tab": () => import('../tabs/Orders.vue'),
      
    },
}
</script>
<template>
 
            <div class="w-full flex flex-wrap">
                <ul class="w-full flex border-b mb-2">
                  
                  <li class="-mb-px mr-1">
                    <a @click.prevent="active = 0" 
                      class="btn-sm text-sm text-gray-900 rounded-t-md inline-block 
                        px-4 font-bold whitespace-no-wrap" 
                      :class="active == 0 ? activeClass : inActiveClass" 
                      href="javascript:void(0)">Prescription List</a>
                  </li>
                  <li class="-mb-px mr-1">
                    <a @click.prevent="active = 1" 
                      class="btn-sm text-sm text-gray-900 rounded-t-md inline-block 
                        px-4 font-bold whitespace-no-wrap" 
                      :class="active == 1 ? activeClass : inActiveClass" 
                      href="javascript:void(0)">Orders List</a>
                  </li>
                 
                </ul>
                <inpatient-tab v-if="active === 0" />
                <inpatientorders-tab v-if="active === 1" />
            </div>
      
</template>
